import styled from 'styled-components';
import {Card} from '../ui/Card';
import {H1, H2} from '../ui/Header';
import Cost, {Cents, Currency, Dollars} from '../ui/Cost';
import Button, {CTAButton} from '../ui/Button';
import Flex from '../ui/Flex';
import {Form, FormButtons, FormContent, FormPair} from '../ui/Form';

const Main = styled.main`
  display: flex;

  & > * + * {
    margin-top: 0;
    margin-left: 1.5em;
  }

  .column-sidebar {
    flex: 1;
    display: flex;
    flex-direction: column; 
  } 

  .column-sidebar > ${Card} {
    flex: 1;  
  }
`

export default function Support() {
  return (
    <Main>
      <Card flex='2'>
        <Flex flexDirection='column' justifyContent='center'>
          <H1>The Wandering Eye Plus</H1>
          <H2>Receive free shipping on all orders!</H2>
          <br/>
          <br/>
          <Flex justifyContent='center' style={{fontSize: '1.5em'}}>
            <Flex style={{width: '50%'}} flexDirection='column' alignItems='center'>
              <small>Starting at</small>
              <Cost>
                <Currency>$</Currency>
                <Dollars>19</Dollars>
                <Cents>.99</Cents>
              </Cost>
              <small>per month</small>
              <CTAButton marginTop='1em'>Sign Up</CTAButton>
            </Flex>
          </Flex>
        </Flex>
      </Card>

      <div className="column-sidebar">
        <Card  paddingBottom='3em'>
          <Form>
            <FormContent>
              <h3>Login</h3>
              <FormPair>
                <label htmlFor="username">Username</label>
                <input id="username" type="text"
                       name="username"/>
              </FormPair>
              <FormPair>
                <label htmlFor="password">Password</label>
                <input id="password" type="password"
                       name="password"/>
              </FormPair>
              <FormButtons>
                <Button type="submit">Login</Button>
              </FormButtons>
            </FormContent>
          </Form>
        </Card>
      </div>
    </Main>
  )
}

